// extracted by mini-css-extract-plugin
module.exports = {"changeTags":"ChangeTags_changeTags__2MBvt"};